import React, { useContext } from "react";
import { Button, Chip, Paper, Stack, Typography } from "@mui/material";
import { QuestionsContext } from "../../../../../../provider/MyContexts";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { ClearButton } from "../../../../components/MyIconButton";

type Props = {
  index: number;
  id: any;
  handleOpenEditor?: () => void;
  targetRef?: React.Ref<HTMLDivElement>;
};

export default function QuestionCard(props: Props) {
  const { index, handleOpenEditor, id, targetRef } = props;
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
  });

  const { questions, handleSelectedChange, removeQuestion } = useContext(QuestionsContext);
  // const { handleModalOpen } = useContext(ModalContext);

  const question = questions[index];
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    // cursor: "grab",
  };

  return (
    <div ref={setNodeRef} style={style}>
      <Paper
        variant="outlined"
        sx={{
          padding: 2,
          display: "flex",
          direction: "row",
          justifyContent: "space-between",
          alignItems: "center",
          ":hover": {
            backgroundColor: "  #f0f0f0",
          },
        }}
        onClick={(event) => {
          event.stopPropagation();
          handleOpenEditor();
          handleSelectedChange(index);
        }}
      >
        <div {...attributes} {...listeners} style={{ cursor: "grab", marginRight: "8px" }}>
          <DragHandleIcon fontSize="small" />
        </div>
        <Stack width={"100%"}>
          <Stack
            direction={"row"}
            spacing={1}
            alignItems={"flex-start"}
            justifyContent={"space-between"}
            marginBottom={1}
            flex={1}
          >
            <Typography variant="label_L" ref={targetRef}>
              {question.questionId + " " + (question.questionTitle || "タイトルなし")}
            </Typography>
            <Chip
              label={question.questionType ? `${question.questionType}` : "未設定"}
              size="small"
            />
          </Stack>
          <Typography variant="body_S" marginRight={1}>
            設問文:{" "}
            {question.questionText.length > 64
              ? question.questionText.slice(0, 64) + "..."
              : question.questionText}
          </Typography>
          <Typography variant="body_S" marginRight={1}>
            表示条件: {question.condition || "ALL/未設定"}
          </Typography>
        </Stack>
        <ClearButton onClick={() => removeQuestion(index)} />
      </Paper>
    </div>
  );
}
